import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=402b3836&scoped=true"
import script from "./Program.vue?vue&type=script&lang=ts"
export * from "./Program.vue?vue&type=script&lang=ts"
import style0 from "./Program.vue?vue&type=style&index=0&id=402b3836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b3836",
  null
  
)

export default component.exports